import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { cn as clsx } from "../../../helpers/react.js";
import { useIndexTableDisabled } from "../IndexTableContext.js";
import '../../../assets/index24.css';const textCell = "_textCell_llhhs_2";
const disabled = "_disabled_llhhs_9";
const onColor = "_onColor_llhhs_19";
const semantic = "_semantic_llhhs_24";
const subdued = "_subdued_llhhs_29";
const value = "_value_llhhs_34";
const label = "_label_llhhs_41";
const isHeader = "_isHeader_llhhs_56";
const caption = "_caption_llhhs_67";
const s = {
  textCell,
  disabled,
  "default": "_default_llhhs_14",
  onColor,
  semantic,
  subdued,
  value,
  label,
  isHeader,
  caption
};
const IndexTableCellText = forwardRef(
  ({ className, label: label2, caption: caption2, variant = "default", isHeader: isHeader2, labelClassName, captionClassName, ...rest }, ref) => {
    const disabled2 = useIndexTableDisabled(rest);
    return /* @__PURE__ */ jsx(
      "div",
      {
        ...rest,
        ref,
        className: clsx(
          s.textCell,
          {
            [s.disabled]: disabled2,
            [s.default]: variant === "default",
            [s.onColor]: variant === "on-color",
            [s.semantic]: variant === "semantic",
            [s.subdued]: variant === "subdued"
          },
          className
        ),
        children: (label2 || caption2) && /* @__PURE__ */ jsxs("div", { className: s.value, children: [
          label2 && /* @__PURE__ */ jsx(
            "div",
            {
              className: clsx(
                s.label,
                {
                  [s.isHeader]: isHeader2
                },
                labelClassName
              ),
              children: label2
            }
          ),
          caption2 && /* @__PURE__ */ jsx(
            "div",
            {
              className: clsx(
                s.caption,
                {
                  [s.isHeader]: isHeader2
                },
                captionClassName
              ),
              children: caption2
            }
          )
        ] })
      }
    );
  }
);
export {
  IndexTableCellText
};
